import React from 'react';
import { motion } from 'framer-motion';
import { ColumviLogo } from './ColumviLogo';
import { ColumviBackground } from './ColumviBackground';
interface HookSlideProps {
  onExplore: () => void;
}
export function HookSlide({
  onExplore
}: HookSlideProps) {
  return <ColumviBackground showWave={false} data-id="element-141">
      <div className="flex flex-col h-full w-full p-6 relative" data-id="element-142">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6
      }} className="absolute top-6 left-6 z-20" data-id="element-143">
          <ColumviLogo size="sm" variant="light" data-id="element-144" />
        </motion.div>

        {/* Abstract SVG Background */}
        <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none flex items-center justify-center opacity-40" data-id="element-145">
          <svg width="400" height="800" viewBox="0 0 400 800" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-146">
            <defs data-id="element-147">
              <linearGradient id="fadeGrad" x1="0" y1="0" x2="0" y2="800" gradientUnits="userSpaceOnUse" data-id="element-148">
                <stop offset="0%" stopColor="rgba(255,255,255,0)" data-id="element-149" />
                <stop offset="50%" stopColor="rgba(255,255,255,0.2)" data-id="element-150" />
                <stop offset="100%" stopColor="rgba(255,255,255,0.8)" data-id="element-151" />
              </linearGradient>
              <linearGradient id="fadeGrad2" x1="0" y1="0" x2="0" y2="800" gradientUnits="userSpaceOnUse" data-id="element-152">
                <stop offset="0%" stopColor="rgba(231,111,36,0)" data-id="element-153" />
                <stop offset="50%" stopColor="rgba(231,111,36,0.1)" data-id="element-154" />
                <stop offset="100%" stopColor="rgba(231,111,36,0.5)" data-id="element-155" />
              </linearGradient>
            </defs>
            <motion.path d="M50,0 L50,200 L100,200 L100,400 L150,400 L150,600 L200,600 L200,800" stroke="url(#fadeGrad)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: 1,
            opacity: 1
          }} transition={{
            duration: 2,
            ease: 'easeInOut'
          }} data-id="element-156" />
            <motion.path d="M150,0 L150,150 L220,150 L220,300 L320,300 L320,500 L400,500 L400,800" stroke="url(#fadeGrad2)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: 1,
            opacity: 1
          }} transition={{
            duration: 2,
            ease: 'easeInOut',
            delay: 0.5
          }} data-id="element-157" />
          </svg>
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col justify-center z-10 mt-16 text-center" data-id="element-158">
          <motion.h1 className="text-white text-3xl leading-tight mb-4" style={{
          fontFamily: 'var(--font-gotham)',
          fontWeight: 800
        }} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-159">
            Curative potential in 2L DLBCL
          </motion.h1>

          <motion.p className="text-white/60 text-lg leading-relaxed mb-10" style={{
          fontFamily: 'var(--font-gotham)'
        }} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-160">
            What should long-term data look like if a treatment truly changes
            outcomes?
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-161">
            <button onClick={onExplore} className="w-full px-8 py-4 rounded-xl text-white text-lg font-semibold transition-all duration-300 border border-white/30 hover:bg-white/10 hover:border-white/60 focus:outline-none focus:ring-2 focus:ring-white/50" style={{
            fontFamily: 'var(--font-gotham)'
          }} data-id="element-162">
              Explore
            </button>
          </motion.div>
        </div>
      </div>
    </ColumviBackground>;
}